import '../styles/Swagger.css'
import React from 'react'
import SwaggerUI from 'swagger-ui-react'
import useRouter from 'use-react-router'
import { Page } from '../components'

const { REACT_APP_BASE_API_URL = '/api' } = process.env

export const Service: React.FC = () => {
  const {
    match: {
      params: { name: relURL },
    },
  } = useRouter<{ name: string }>()

  return (
    <Page title="Service">
      <SwaggerUI url={`${REACT_APP_BASE_API_URL}/specs/${relURL}`} />
    </Page>
  )
}
